import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=f9b662de&scoped=true"
import script from "./BaseAlert.vue?vue&type=script&lang=js"
export * from "./BaseAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9b662de",
  null
  
)

export default component.exports